import { createContext, useContext } from "react";

export const PilotAccessContext = createContext({
  readOnly: false,
  timezone: "America/Sao_Paulo",
  refreshError: null as string | null,
  warning: false,
  until: null as string | null,
  refresh: () => {},
});
export const usePilotAccess = () => useContext(PilotAccessContext);
